module.exports = "\r\n<vis-graph2d data=\"data\" options=\"options\"></vis-graph2d>\r\n<vis-timeline data=\"data_timeline\" options=\"options\" events=\"events\"></vis-timeline>\r\n";


//////////////////
// WEBPACK FOOTER
// ./js/dashboard/graphs.html
// module id = 149
// module chunks = 0